import { useState } from 'react';
import { ManageLoanDrawer } from './components/ManageLoanDrawer/ManageLoanDrawer.tsx';
import { DataLoanDefinitionTct } from '@dealstack/shared/lib/generated';
import { useCreateLoan } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/Loans/components/hooks/useCreateLoan.ts';
import { useUpdateLoan } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/Loans/components/hooks/useUpdateLoan.ts';
import { useDeleteLoan } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/Loans/components/hooks/useDeleteLoan.ts';
import { useGetLoans } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/Loans/components/hooks/useGetLoans.ts';
import { LoanFormData } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/Loans/types.ts';
import { LoanTable as LoansTable } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/Loans/components/LoansTable/LoanTable.tsx';
import { StyledSettingsContainer } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/styles.ts';

export const Loans = ({ mipId }: { mipId: string }) => {
	const [selectedLoan, setSelectedLoan] = useState<DataLoanDefinitionTct | null>(null);
	const [isDrawerOpen, setIsDrawerOpen] = useState(false);

	const { data: loansData, isLoading: isLoansLoading, refetch: refetchLoans } = useGetLoans();

	const { mutate: createLoan, isPending: isCreating } = useCreateLoan({
		onSuccess: refetchLoans,
	});

	const { mutate: updateLoan, isPending: isUpdating } = useUpdateLoan({
		onSuccess: refetchLoans,
	});

	const { mutate: deleteLoan, isPending: isDeleting } = useDeleteLoan({
		onSuccess: refetchLoans,
	});

	const handleEdit = (loan: DataLoanDefinitionTct) => {
		setSelectedLoan(loan);
		setIsDrawerOpen(true);
	};

	const handleAdd = () => {
		setSelectedLoan(null);
		setIsDrawerOpen(true);
	};

	const handleSaveLoan = (loan: LoanFormData) => {
		if (loan.id) {
			updateLoan({
				loanDefinitionId: loan.id,
				type: loan.type,
				name: loan.name,
				funderPersonId: loan.funderIsNew ? undefined : loan.funderId,
				funderPersonNameToCreate: loan.funderIsNew ? loan.funderName : undefined,
				mipId,
			});
		} else {
			createLoan({
				loansDefinitions: [
					{
						type: loan.type,
						name: loan.name,
						mipId,
						funderPersonId: loan.funderIsNew ? undefined : loan.funderId,
						funderPersonNameToCreate: loan.funderIsNew ? loan.funderName : undefined,
					},
				],
			});
		}
	};

	const handleRemoveLoan = (loanId: string) => {
		deleteLoan({ loanDefinitionId: loanId });
	};

	const closeDrawer = () => {
		setIsDrawerOpen(false);
	};

	const loans = loansData?.payload || [];
	const isLoading = isLoansLoading || isCreating || isUpdating || isDeleting;

	return (
		<StyledSettingsContainer>
			<LoansTable loans={loans} isLoading={isLoading} onEdit={handleEdit} onAdd={handleAdd} />

			<ManageLoanDrawer
				opened={isDrawerOpen}
				onClose={closeDrawer}
				loanData={selectedLoan}
				onSave={handleSaveLoan}
				onRemove={handleRemoveLoan}
			/>
		</StyledSettingsContainer>
	);
};
